export const mealPlanningRoutes = [
    {
        path: '/menu',
        meta: { requiresHousehold: true },
        children: [
          {
            path: 'day',
            children: [
              {
                path: '',
                component: () => import(/* webpackChunkName: "menu" */ '@/features/meal-planning/views/MealPlanningMenuDay.vue'),
              },
              {
                path: ':year/:month/:day',
                component: () => import(/* webpackChunkName: "menu" */ '@/features/meal-planning/views/MealPlanningMenuDay.vue'),
              }
            ]
          },
          {
            path: 'week',
            children: [
              {
                path: '',
                component: () => import(/* webpackChunkName: "menu" */ '@/features/meal-planning/views/MealPlanningMenuWeek.vue'),
              },
              {
                path: ':year/:week',
                component: () => import(/* webpackChunkName: "menu" */ '@/features/meal-planning/views/MealPlanningMenuWeek.vue'),
              }
            ]
          },
          {
            path: 'month',
            children: [
              {
                path: '',
                component: () => import(/* webpackChunkName: "menu" */ '@/features/meal-planning/views/MealPlanningMenuMonth.vue'),
              },
              {
                path: ':year/:month',
                component: () => import(/* webpackChunkName: "menu" */ '@/features/meal-planning/views/MealPlanningMenuMonth.vue'),
              }
            ]
          }
        ]
    }
]
